import { lazy } from 'react';
import { retry } from './helpers/utils';

const ConnectedHome = lazy(() => retry(() => import('./containers/pages/Home' /* webpackChunkName: "Home" */)));
const PDS = lazy(() => retry(() => import('./containers/pages/PDS' /* webpackChunkName: "PDS" */)));
const StaticPage = lazy(() => retry(() => import('./containers/pages/StaticPage' /* webpackChunkName: "Static" */)));
const Help = lazy(() => retry(() => import('./containers/pages/Help' /* webpackChunkName: "Help" */)));
const ConnectedCOI = lazy(() => retry(() => import('./containers/pages/COI' /* webpackChunkName: "COI" */)));
const Login = lazy(() => retry(() => import('./containers/pages/Login' /* webpackChunkName: "Login" */)));
const ConfirmSignUp = lazy(() =>
  retry(() => import('./containers/pages/ConfirmSignUp' /* webpackChunkName: "ConfirmSignUp" */)),
);
const ForgotPassword = lazy(() =>
  retry(() => import('./containers/pages/ForgotPassword' /* webpackChunkName: "ForgotPassword" */)),
);
const ForgotPasswordSubmit = lazy(() =>
  retry(() => import('./containers/pages/ForgotPasswordSubmit' /* webpackChunkName: "ForgotPasswordSubmit" */)),
);
const Account = lazy(() => retry(() => import('./containers/pages/Account' /* webpackChunkName: "Account" */)));
const ConnectedProfile = lazy(() =>
  retry(() => import('./containers/pages/Profile' /* webpackChunkName: "Profile" */)),
);
const ConnectedPayout = lazy(() => retry(() => import('./containers/pages/Payout' /* webpackChunkName: "Payout" */)));
const Logout = lazy(() => retry(() => import('./containers/pages/Logout' /* webpackChunkName: "Logout" */)));
const ConnectedFNOL = lazy(() => retry(() => import('./containers/pages/FNOL' /* webpackChunkName: "FNOL" */)));
const ConnectedFNOLClaimDetails = lazy(() =>
  retry(() => import('./containers/pages/FNOLClaimDetails' /* webpackChunkName: "FNOLClaimDetails" */)),
);
const ConnectedFNOLClaimQuestions = lazy(() =>
  retry(() => import('./containers/pages/FNOLClaimQuestions' /* webpackChunkName: "FNOLClaimQuestions" */)),
);
const FNOLSections = lazy(() =>
  retry(() => import('./containers/pages/FNOLSections' /* webpackChunkName: "FNOLSections" */)),
);
const FNOLSubmitted = lazy(() =>
  retry(() => import('./containers/pages/FNOLSubmitted' /* webpackChunkName: "FNOLSubmitted" */)),
);
const FNOLExcessCollection = lazy(() =>
  retry(() => import('./containers/pages/FNOLExcessCollection' /* webpackChunkName: "FNOLExcessCollection" */)),
);
const PayoutSubmitted = lazy(() =>
  retry(() => import('./containers/pages/PayoutSubmitted' /* webpackChunkName: "PayoutSubmitted" */)),
);
const Quote = lazy(() => retry(() => import('./containers/pages/Quote' /* webpackChunkName: "Quote" */)));
const QuotePolicyholder = lazy(() =>
  retry(() => import('./containers/pages/Quote/QuotePolicyholder' /* webpackChunkName: "QuotePolicyholder" */)),
);
const QuotePaymentPage = lazy(() =>
  retry(() => import('./containers/pages/Quote/QuotePaymentPage' /* webpackChunkName: "QuotePaymentPage" */)),
);
const QuoteConfirmed = lazy(() =>
  retry(() => import('./containers/pages/Quote/QuoteConfirmed' /* webpackChunkName: "QuoteConfirmed" */)),
);
const HelpLanding = lazy(() =>
  retry(() => import('./containers/pages/HelpLanding' /* webpackChunkName: "HelpLanding" */)),
);
const HelpArticleLists = lazy(() =>
  retry(() => import('./containers/pages/HelpArticleLists' /* webpackChunkName: "HelpArticleLists" */)),
);
const QuoteLanding = lazy(() =>
  retry(() => import('./containers/pages/Quote/QuoteLanding' /* webpackChunkName: "QuoteLanding" */)),
);
const ConnectedModifyBooking = lazy(() =>
  retry(() => import('./containers/pages/ModifyBooking' /* webpackChunkName: "ModifyBooking" */)),
);
const PaypalInterstitial = lazy(() =>
  retry(() => import('./containers/pages/PaypalInterstitial' /* webpackChunkName: "PaypalInterstitial" */)),
);
const Impersonate = lazy(() =>
  retry(() => import('./containers/pages/Impersonate' /* webpackChunkName: "Impersonate" */)),
);

export const localePrefix = '/:locale([a-zA-Z_-]{2,})';
export const routes = [
  {
    key: 'home',
    path: `${localePrefix}/`,
    exact: true,
    component: ConnectedHome,
  },
  {
    key: 'pds',
    path: `${localePrefix}/pds/:id`,
    exact: true,
    component: PDS,
  },
  {
    key: 'coi',
    path: `${localePrefix}/coi/:id`,
    exact: true,
    component: ConnectedCOI,
  },
  {
    key: 'help',
    path: `${localePrefix}/help/:slug`,
    exact: true,
    component: Help,
  },
  {
    key: 'helpLanding',
    path: [`${localePrefix}/help`, `${localePrefix}/help#:hashId`],
    exact: true,
    component: HelpLanding,
  },
  {
    key: 'helpArticleLists',
    path: `${localePrefix}/help/:type(partners|categories)/:slug`,
    exact: true,
    component: HelpArticleLists,
  },
  {
    key: 'quoteLanding',
    path: `${localePrefix}/get-quote/:insuranceLine`,
    component: QuoteLanding,
  },
  {
    key: 'quote',
    path: `${localePrefix}/quote/:quotePackageID`,
    exact: true,
    component: Quote,
  },
  {
    key: 'quotePolicyholder',
    path: `${localePrefix}/quote/:quotePackageID/policyholder`,
    exact: true,
    component: QuotePolicyholder,
  },
  {
    key: 'quotePayment',
    path: `${localePrefix}/quote/:quotePackageID/payment`,
    exact: true,
    component: QuotePaymentPage,
  },
  {
    key: 'quoteConfirmed',
    path: `${localePrefix}/quote/:bookingID/confirmed`,
    exact: true,
    component: QuoteConfirmed,
  },
  {
    key: 'fnolSubmitted',
    path: `${localePrefix}/account/claims/fnol/submitted`,
    exact: true,
    component: FNOLSubmitted,
  },
  {
    key: 'fnolSections',
    path: `${localePrefix}/account/claims/fnol/sections`,
    component: FNOLSections,
  },
  {
    key: 'fnolQuestions',
    path: `${localePrefix}/account/claims/fnol/questions/:currentDecisionPointId?`,
    exact: true,
    component: ConnectedFNOLClaimQuestions,
  },
  {
    key: 'fnol',
    path: `${localePrefix}/account/claims/fnol`,
    exact: true,
    component: ConnectedFNOL,
  },
  {
    key: 'fnolClaimDetails',
    path: `${localePrefix}/account/claims/fnol/claim-details`,
    exact: true,
    component: ConnectedFNOLClaimDetails,
  },
  {
    key: 'impersonate',
    path: `${localePrefix}/impersonate`,
    exact: true,
    component: Impersonate,
  },
  {
    key: 'page',
    path: `${localePrefix}/:slug*`,
    exact: true,
    component: StaticPage,
  },
];

export const unauthRoutes = [
  {
    key: 'login',
    path: `${localePrefix}/login`,
    exact: true,
    component: Login,
  },
  {
    key: 'confirmSignUp',
    path: `${localePrefix}/signup/confirm`,
    exact: true,
    component: ConfirmSignUp,
  },
  {
    key: 'forgotPassword',
    path: `${localePrefix}/forgot-password`,
    exact: true,
    component: ForgotPassword,
  },
  {
    key: 'forgotPasswordSubmit',
    path: `${localePrefix}/forgot-password/confirm`,
    exact: true,
    component: ForgotPasswordSubmit,
  },
];

export const authRoutes = [
  {
    key: 'account',
    path: `${localePrefix}/account`,
    exact: true,
    component: Account,
  },
  {
    key: 'profile',
    path: `${localePrefix}/profile`,
    exact: true,
    component: ConnectedProfile,
  },
  {
    key: 'claimPayoutSubmitted',
    path: `${localePrefix}/account/claims/:claimReference/payout/:payoutID/submitted`,
    exact: true,
    component: PayoutSubmitted,
  },
  {
    key: 'payoutSubmitted',
    path: `${localePrefix}/account/payout/:payoutID/submitted`,
    exact: true,
    component: PayoutSubmitted,
  },
  {
    key: 'claimPayout',
    path: `${localePrefix}/account/claims/:claimReference/payout/:payoutID`,
    exact: true,
    component: ConnectedPayout,
  },
  {
    key: 'fnolExcessCollection',
    path: `${localePrefix}/account/claims/fnol/excess`,
    exact: true,
    component: FNOLExcessCollection,
  },
  {
    key: 'payout',
    path: `${localePrefix}/account/payout/:payoutID`,
    exact: true,
    component: ConnectedPayout,
  },
  {
    key: 'paypalInterstitial',
    path: `${localePrefix}/paypal-connect`,
    exact: true,
    component: PaypalInterstitial,
  },
  {
    key: 'modifyBooking',
    path: `${localePrefix}/modify/:id`,
    exact: true,
    component: ConnectedModifyBooking,
  },
  {
    key: 'logout',
    path: `${localePrefix}/logout`,
    exact: true,
    component: Logout,
  },
];
